import * as React from "react";
import PropTypes from "prop-types";
import Theme from "../../Theme";
import ThermostatSetpoints from "../../Thermostat/ThermostatSetpoints";

const styles = {
  field: {
    padding: Theme.Padding.CONTENT,
  },
};

export default class ThermostatSetpointField extends React.Component {
  static propTypes = {
    value: PropTypes.shape({
      heat: PropTypes.number,
      cool: PropTypes.number,
    }).isRequired,
    /* eslint-disable camelcase */
    min_heat_setpoint: PropTypes.number.isRequired,
    max_heat_setpoint: PropTypes.number.isRequired,
    min_cool_setpoint: PropTypes.number.isRequired,
    max_cool_setpoint: PropTypes.number.isRequired,
    /* eslint-enable camelcase */
    delta: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    onChange: PropTypes.func,
  };

  UNSAFE_componentWillMount() {
    const { value, onChange } = this.props;
    let stateValue = this._getStateValue(value);
    this.setState({ value: stateValue });

    if (onChange && (value.heat == null || value.cool == null)) {
      onChange(stateValue); // we're changing the value, we're just doing it very early.
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let newValue = this._getStateValue(nextProps.value);
    if (
      newValue.heat !== this.state.value.heat ||
      newValue.cool !== this.state.value.cool
    ) {
      this.setState({ value: newValue });
    }
  }

  _getStateValue = (value) => {
    // A factory-reset thermostat doesn't always provide a value, so use the min.
    return {
      heat: value.heat || this.props.min_heat_setpoint,
      cool: value.cool || this.props.min_cool_setpoint,
    };
  };

  state = {
    value: this.props.value,
  };

  _handleChange = (setpoints) => {
    let newSetpoints = {
      heat: setpoints.setpointHeat,
      cool: setpoints.setpointCool,
    };
    this.props.onChange(newSetpoints);
    this.setState({
      value: newSetpoints,
    });
  };

  render() {
    const {
      min_heat_setpoint: minHeatSetpoint,
      max_heat_setpoint: maxHeatSetpoint,
      min_cool_setpoint: minCoolSetpoint,
      max_cool_setpoint: maxCoolSetpoint,
      delta,
      step,
    } = this.props;
    const { value } = this.state;

    return (
      <div data-component-name="ThermostatSetpointField" style={styles.field}>
        <ThermostatSetpoints
          onChangesEnded={this._handleChange}
          changeBufferMs={0}
          setpointHeat={value.heat}
          setpointCool={value.cool}
          setpointHeatMin={minHeatSetpoint}
          setpointHeatMax={maxHeatSetpoint}
          setpointCoolMin={minCoolSetpoint}
          setpointCoolMax={maxCoolSetpoint}
          setpointDelta={delta}
          setpointIncrement={step}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/ThermostatSetpointField.jsx